import {ClinkerClassificationInputNames, MaterialType} from '@domain/materials'

import {ClassificationHeaderCells} from './ClassificationHeaderCells'

import {SHORT_COLUMN_WIDTH} from '@settings/modules/common/consts'

const clinkerFields = [
  {key: ClinkerClassificationInputNames.Type},
  {key: ClinkerClassificationInputNames.Grade},
  {key: ClinkerClassificationInputNames.SulphateResistance},
  {key: ClinkerClassificationInputNames.AlkaliContent, minWidth: SHORT_COLUMN_WIDTH},
  {key: ClinkerClassificationInputNames.LowHeat, minWidth: SHORT_COLUMN_WIDTH}
]

export const ClinkerClassificationHeader = () => {
  return <ClassificationHeaderCells fields={clinkerFields} materialType={MaterialType.Clinker} />
}
